<template>
  <div class="content-panel">
    <a-card :bordered="false">
      <a-input-search
        v-model="searchValue"
        style="margin-bottom: 8px"
        placeholder="请输入部门名称"
        @search="queryDeptData"
      />

      <a-tree
        :treeData="treeData"
        :draggable="$auth('baseInfo.drag_dept')"
        @expand="onExpand"
        :expandedKeys="expandedKeys"
        @select="select"
        :defaultSelectedKeys="defaultSelectedKeys"
        :autoExpandParent="autoExpandParent"
      >
        <template slot="custom" slot-scope="item">
          <span>{{ item.name }}</span>
        </template>
      </a-tree>
    </a-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { createSysDept, editSysDept, deleteSysDept, dragSysDept } from '@/api/baseInfo.js'
import { getSysDeptList } from '@/api/assessment.js'

export default {
  name: 'OrgTree',
  components: {
  },
  data () {
    return {
      title: '',
      treeData: [],
      searchValue: '',
      dragSort: Number,
      autoExpandParent: true,
      expandedKeys: [],
      defaultSelectedKeys: ['0-0'],
      isAppend: false,
      firstLogin: true,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      pNode: {},
      type: '',
      chartData: {},
      userList: []
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    this.queryDeptData()
  },
  methods: {
    ...mapActions(['handleAssessDept', 'handleDeptList']),
    editOrg (data) {
      this.$refs.editDept.setTitle('编辑组织机构')
      this.$refs.editDept.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editDept.setModel(data)
      this.$refs.editDept.open(true)
    },
    deleteOrg (id) {
      const query = {
        ids: id
      }

      deleteSysDept(query).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          this.queryDeptData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }

          if (this.type === 'MODAL_ADD') {
            if (this.pNode) {
              params.pid = this.pNode.id
              params.level = this.pNode.level + ',' + this.pNode.id
            } else {
              params.pid = 0
              params.level = '0'
            }

            createSysDept(params).then(res => {
              if (res.status === 0) {
                this.$message.success('新增成功')
                this.$emit('reGetData')
                this.queryDeptData()
                this.cancel()
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else {
            params.id = this.pNode.id
            params.pid = this.pNode.pid
            params.level = this.pNode.level

            if (this.pNode.status === 3) {
              params.status = 0
            }

            editSysDept(params).then(res => {
              if (res.status === 0) {
                this.$message.success('编辑成功')
                this.$emit('reGetData')
                this.queryDeptData()
                this.cancel()
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    cancel () {
      this.visible = false
      this.form.resetFields()
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      // this.autoExpandParent = false
    },
    // 获取部门列表树数据
    async queryDeptData () {
      const query = {
        name: this.searchValue
      }
      if (this.searchValue === '') {
        delete query.name // 删除对应对象
      }
      const res = await getSysDeptList(query)

      if (res.status === 0) {
        this.treeData = res.data
        // 默认第一条数据被选中
           
        if (this.firstLogin) {
          if (this.treeData.length > 0) {
            const selectedItem = this.treeData[0]

            if (selectedItem.pid === 0) {
              selectedItem.pName = '一级组织机构'
            }
            this.handleAssessDept(selectedItem)
            this.firstLogin = false
          }
        }
      } else {
        this.$message.error(res.info.message)
      }
    },
    deleteChildren (arr) {
      const childs = arr
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.deleteChildren(childs[i].children)
          } else {
            delete childs[i].children
          }
        }
      }
      return arr
    },
    // 递归查找
    searchOption (option, arr, type = 'delect') {
      for (let s = 0; s < arr.length; s++) {
        if (arr[s].key === option.key) {
          if (type === 'delect') {
            arr.splice(s, 1)
          }
          break
        } else if (arr[s].children && arr[s].children.length > 0) {
          // 递归条件
          this.searchOption(option, arr[s].children)
        } else {
          continue
        }
      }
    },
    // 选择一个字典
    select (data, info) {
      if (info.selectedNodes.length) {
        this.expandedKeys.push(data[0])
        this.expandedKeys = Array.from(new Set(this.expandedKeys))

        var selectedItem = info.selectedNodes[0].data.props
        if (selectedItem.pid === 0) {
          selectedItem.pName = '一级组织机构'
        }
        selectedItem.key = info.node.dataRef.key

        if (!this.isAppend) {
          this.handleAssessDept(selectedItem)
          this.$emit('formNavTitle', '编辑字典')
        }
      } else {
        this.handleAssessDept({})
      }
      this.isAppend = false
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
<style lang="less">
.ant-modal-body{
  #chart-container{
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  // .ant-tree-title {
  //   width: 100%;

  //   & > span {
  //     // width: 90px;
  //     display: inline-block;
  //     white-space: pre-line;
  //   }
  // }
  // .title {
  //   float: left;
  // }

  .ant-card-body {
    padding: 0;
    
    .ant-btn {
      margin-bottom: 12px;
    }

    // :global {
    //   .ant-tree {
    //     line-height: 3;

    //     .ant-tree-node-content-wrapper,
    //     .ant-tree-switcher {
    //       margin-top: 7px;
    //     }
    //     .ant-tree-node-content-wrapper:hover {
    //       background: transparent;
    //     }
    //     .ant-tree-treenode-selected {
    //       background: #e6f7ff;
    //       .ant-tree-node-selected {
    //         background: transparent;
    //       }
    //     }

    //     .ant-tree-child-tree {
    //       background: #fff;
    //     }
    //     li {
    //       position: relative;
    //       line-height: 3;
    //       padding-bottom: 0;
    //     }
    //   }
    // }

    // .icon-panel {
    //   float: right;
    //   position: absolute;
    //   right: 10px;
    //   top: 13px;

    //   .anticon-plus,
    //   .anticon-setting,
    //   .anticon-edit,
    //   .anticon-delete {
    //     margin-left: 5px;
    //     color: #1890ff;
    //   }
    // }
  }
}
</style>
